<template>
    <div class="confirm-popup">
        <p>{{  $t('msg-confirmacao') }}</p>
        <div class="form-buttons confirm">
            <button class="delete-btn" type="button" @click="cancelChanges()">
                {{ $t('nao') }}
            </button>
            <button class="save-btn" type="button" @click="confirm()">
                {{ $t('msg-confirmar') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        val: { 
            default: () => {return {}}
        },
    },
    data(){
        return{
            grandparent: this.$parent.$parent,
        }
    },

    methods:{
        cancelChanges(){
            this.$parent.closeModal();
        },
        confirm(){
            this.val.del = true;
            this.grandparent.$emit('delete', this.val);
            this.$parent.closeModal();
        }
    }
}
</script>

<style lang="scss">

.confirm-popup{
    position: relative;
    p{
        font-size: 16px;
        text-align: center;
    }

    .form-buttons {
        position: relative;
        top: 0;
        right: 0;
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        
        .save-btn,
        .delete-btn{
            color: $sovis-white;
            font-size: 12px;
            text-align: center;
            padding: 5px 25px;
            height: 35px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            margin-left: 20px;
            @include gradient-button();
        }
        .delete-btn {
            left: 0;
            color: $darker-gray-color;
            @include exclude-button();
        }
    }
}

</style>
